import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

export const changeUsernameRequested = () => ({
  type: SettingsActionTypes.CHANGE_USERNAME_REQUESTED,
  isChangingUsername: true,
});

export const changeUsernameSuccess = (response, username) => ({
  type: SettingsActionTypes.CHANGE_USERNAME_SUCCESS,
  isChangingUsername: false,
  isSuccess: response.isSuccess,
  message: response.message,
  username,
});

export const changeUsernameFailure = error => ({
  type: SettingsActionTypes.CHANGE_USERNAME_FAILURE,
  isChangingUsername: false,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * CHANGE USERNAME
 -----------------------------------------------------------------------------*/
export default changeUsername(new SettingsService());

export function changeUsername(service) {
  return username => async (dispatch) => {
    dispatch(changeUsernameRequested());

    try {
      const { data } = await service.changeUsername(username);
      dispatch(changeUsernameSuccess(data, username));
      return data;
    } catch (error) {
      dispatch(changeUsernameFailure(error));
      return error;
    }
  };
}